import _extends from 'babel-runtime/helpers/extends';
export var DEV_ONLY_LOGIN = 'DEV_ONLY_LOGIN';
export var TOKEN_RECEIVED = 'TOKEN_RECEIVED';
export var LOGOUT = 'LOGOUT';
export var REFRESH_TOKEN = 'REFRESH_TOKEN';
export var TOKEN_NOT_RECEIVED = 'TOKEN_NOT_RECEIVED';
export var LOGIN_VIA_TOKEN = 'LOGIN_VIA_TOKEN';
export var INIT_USER = 'INIT_USER';
export var SEND_FEEDBACK = 'SEND_FEEDBACK';

var SET_UI_LANGUAGE = 'SET_UI_LANGUAGE';
export var USER_INITIALIZED = 'USER_INITIALIZED';

var initialState = {
  initialized: false,
  loggingIn: false,
  user: undefined,
  overrideUILanguage: undefined,
  refreshTokenFailed: false
};

export var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case DEV_ONLY_LOGIN:
    case LOGIN_VIA_TOKEN:
      {
        return _extends({}, state, {
          loggingIn: true
        });
      }
    case TOKEN_RECEIVED:
      {
        var userJson = action.payload.userJson;

        return _extends({}, state, {
          loggingIn: false,
          user: userJson
        });
      }
    case TOKEN_NOT_RECEIVED:
      {
        return _extends({}, state, {
          refreshTokenFailed: true,
          loggingIn: false,
          user: undefined
        });
      }
    case USER_INITIALIZED:
      {
        return _extends({}, state, {
          initialized: true
        });
      }
    case LOGOUT:
      {
        return _extends({}, state, {
          user: undefined,
          initialized: false,
          refreshTokenFailed: false
        });
      }
    case SET_UI_LANGUAGE:
      {
        return _extends({}, state, {
          overrideUILanguage: action.payload.language
        });
      }
    case INIT_USER:
    case REFRESH_TOKEN:
    case SEND_FEEDBACK:
      return state;
    default:
      return state;
  }
};

export var userActions = {
  devLogin: function devLogin(username, password, rememberMe) {
    return {
      type: DEV_ONLY_LOGIN,
      payload: { username: username, password: password, rememberMe: rememberMe }
    };
  },
  tokenReceived: function tokenReceived(userJson, rememberMe) {
    return {
      type: TOKEN_RECEIVED,
      payload: { userJson: userJson, rememberMe: rememberMe }
    };
  },
  tokenNotReceived: function tokenNotReceived() {
    return { type: TOKEN_NOT_RECEIVED };
  },
  logout: function logout() {
    return { type: LOGOUT };
  },
  refreshToken: function refreshToken() {
    return { type: REFRESH_TOKEN };
  },
  loginViaToken: function loginViaToken(token) {
    var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return { type: LOGIN_VIA_TOKEN, payload: { token: token, rememberMe: rememberMe } };
  },
  initializeUser: function initializeUser() {
    return { type: INIT_USER };
  },
  setUserInitialized: function setUserInitialized() {
    return { type: USER_INITIALIZED };
  },
  setUILanguage: function setUILanguage(language) {
    return { type: SET_UI_LANGUAGE, payload: { language: language } };
  },
  sendFeedback: function sendFeedback(feedbackText) {
    return {
      type: SEND_FEEDBACK,
      payload: { feedbackText: feedbackText }
    };
  }
};

var getEgoUser = function getEgoUser(state) {
  if (state.user && state.user.user) {
    return state.user.user.egoUser;
  }
  return undefined;
};

// reuse this object instead of making a new one for each userLanguages call
//  to avoid unnecessary renders
var userLanguageObject = {
  learningLanguage: '',
  interfaceLanguage: ''
};
var userLanguages = function userLanguages(state) {
  var egoUser = getEgoUser(state);
  if (!egoUser) {
    userLanguageObject.learningLanguage = '';
    userLanguageObject.interfaceLanguage = state.user.overrideUILanguage;
  } else {
    userLanguageObject.learningLanguage = egoUser.targetLanguage.language;
    userLanguageObject.interfaceLanguage = state.user.overrideUILanguage ? state.user.overrideUILanguage : egoUser.interfaceLanguage;
  }
  return userLanguageObject;
};

var _getUserProductRights = function _getUserProductRights(state) {
  if (state.user && state.user.user && state.user.user.products && state.user.user.products.productRights) {
    return state.user.user.products.productRights;
  }
  return [];
};

export var userSelectors = {
  getLanguages: function getLanguages(state) {
    return userLanguages(state);
  },
  getUILanguage: function getUILanguage(state) {
    return userLanguages(state).interfaceLanguage;
  },
  getLearningLanguage: function getLearningLanguage(state) {
    return userLanguages(state).learningLanguage;
  },
  getCefr: function getCefr(state) {
    var egoUser = getEgoUser(state);
    if (egoUser && egoUser.targetLanguage) {
      return egoUser.targetLanguage.level;
    }
    return undefined;
  },
  getUserProductRights: function getUserProductRights(state) {
    return _getUserProductRights(state);
  },
  getFirstProductId: function getFirstProductId(state) {
    var userProductRights = _getUserProductRights(state);
    if (userProductRights[0]) {
      return userProductRights[0].productId;
    }
    return '';
  },
  isLoggingIn: function isLoggingIn(state) {
    return state.user.loggingIn;
  },
  isLoggedIn: function isLoggedIn(state) {
    if (state.user) {
      return !!state.user.user;
    }
    return false;
  },
  isWebiUser: function isWebiUser(state) {
    var userProductRights = _getUserProductRights(state);
    var WEBI_PRODUCTS = ['product.5c49ea4d-767f-4672-d60f-43274498516f', 'product.8c3d3ec6-aa91-e298-0838-c87f9c63492d', 'product.a7d387bb-79c6-771a-9ea3-9e4025133680'];
    return userProductRights.find(function (p) {
      return WEBI_PRODUCTS.find(function (w) {
        return w === p.productId;
      });
    }) !== undefined;
  },
  refreshTokenFailed: function refreshTokenFailed(state) {
    return state.user.refreshTokenFailed;
  },
  getUserEmail: function getUserEmail(state) {
    var egoUser = getEgoUser(state);
    return egoUser ? egoUser.email : '';
  },
  getUserFirstName: function getUserFirstName(state) {
    var egoUser = getEgoUser(state);
    return egoUser ? egoUser.firstName : '';
  },
  getUserLastName: function getUserLastName(state) {
    var egoUser = getEgoUser(state);
    return egoUser ? egoUser.lastName : '';
  },
  getUserVoiceType: function getUserVoiceType(state) {
    var egoUser = getEgoUser(state);
    return egoUser ? egoUser.preferences.voiceType : '';
  },
  getUserId: function getUserId(state) {
    var egoUser = getEgoUser(state);
    return egoUser ? egoUser.gui : undefined;
  },
  isTutoringAvailable: function isTutoringAvailable(state) {
    return !!state.user.user && state.user.user.tutoringType && (state.user.user.tutoringType.groupTutoring === 'true' || state.user.user.tutoringType.privateTutoring === 'true');
  },
  getChosenLanguageStandard: function getChosenLanguageStandard(state) {
    if (state.user && state.user.user) {
      return state.user.user.egoOrganization.chosenLanguageStandard;
    }
    return 'CEFR';
  },

  // this is a sharp tool please use it carefully
  getAllUserInfo: function getAllUserInfo(state) {
    return state.user.user;
  },
  isUserInitialized: function isUserInitialized(state) {
    return state.user.initialized;
  },
  getAccessToken: function getAccessToken(state) {
    return state.user ? state.user.user.access_token : null;
  }
};